import LayOut from '../components/common/Layout';
import { Button } from '../components/common/Button';
import { Link } from 'react-router-dom';
import { Routes } from '../utils/Routes';

export default function NotFound() {
  return (
    <LayOut>
      <div className="relative w-full min-h-screen flex flex-col items-center justify-center px-4">
        {/* Content */}
        <div className="text-center max-w-2xl mx-auto">
          {/* Error Code */}
          <div className="mb-8">
            <h1 className="text-8xl md:text-9xl font-bold text-gray-400 opacity-50 mb-2">
              404
            </h1>
          </div>

          {/* Main Message */}
          <div className="mb-8 space-y-4">
            <h2 className="text-2xl md:text-3xl font-semibold text-white">
              Page Not Found
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed">
              The page you're looking for seems to have wandered into the void.
            </p>
          </div>

          {/* Navigation Options - Same as Home page */}
          <div className="flex flex-col md:flex-row justify-center gap-4 mt-6 w-full max-w-xl mx-auto">
            <Link to={Routes.Art} className="flex-1 min-w-0 group">
              <Button
                label="Art"
                className="w-full h-14 rounded-full border border-yellow-500 text-yellow-200 font-semibold transition-all duration-200 hover:text-yellow-100 focus:outline-none focus:ring-2 focus:ring-yellow-200 flex items-center justify-center text-base tracking-wide"
              />
            </Link>
            <Link to={Routes.Thoughts} className="flex-1 min-w-0 group">
              <Button
                label="Thoughts"
                className="w-full h-14 rounded-full border border-blue-200 text-blue-100 font-semibold transition-all duration-200 hover:text-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-100 flex items-center justify-center text-base tracking-wide"
              />
            </Link>
            <Link to={Routes.Music} className="flex-1 min-w-0 group">
              <Button
                label="Music"
                className="w-full h-14 rounded-full border border-indigo-200 text-indigo-100 font-semibold transition-all duration-200 hover:text-indigo-50 focus:outline-none focus:ring-2 focus:ring-indigo-200 flex items-center justify-center text-base tracking-wide"
              />
            </Link>
          </div>
        </div>
      </div>
    </LayOut>
  );
}
